import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=83a7234a"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports